// @flow

import type {ModalProps} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import GoTrashcan from 'react-icons/lib/go/trashcan'
import {uiActions} from '@/store'

type Props = {
  onConfirm: () => void,
  showConfirmModal: (props: ModalProps) => void,
  id?: string,
  message:'',
}

export class RawDeleteButton extends Component<Props> {
  onClick = () =>
    this.props.showConfirmModal({
      onConfirm: this.props.onConfirm,
      message: this.props.message,
    })

  render = () =>
    <a id={this.props.id} onClick={this.onClick}><GoTrashcan /></a>
}

export default connect(
  null,
  uiActions,
)(RawDeleteButton)



// WEBPACK FOOTER //
// ./src/controls/delete-button.js